// extracted by mini-css-extract-plugin
module.exports = {"titlePopUp":"TitleCustom_titlePopUp__2cuGT"};